import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../models/users/userService';
import { BasePage } from '../BasePage';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-signout',
    templateUrl: './signout.component.html',
    standalone: false
})
export class SignoutComponent extends BasePage {

  constructor(private router: Router, private userService: UserService) {
    super();

    this.userService.signout();
    window.location.href = environment.suiteUrl + "/sign-in";

  }

  // override ngOnInit() {
  //   super.ngOnInit();

  //   this.userService.signout();
  //   window.location.href = "https://suite.local.swipesum.com/sign-in";
  // }

}
